export const parseJwt = <T>(token: string): (T & { exp: string }) | null => {
  if (!token) {
    return null;
  }
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join("")
    );

    return JSON.parse(jsonPayload);
  } catch (e) {
    console.error("Failed to parse JWT:", e);
    return null;
  }
};

export const isJwtExpired = (token: string): boolean => {
  const payload = parseJwt(token);
  if (!payload?.exp) {
    return true;
  }

  const currentTime = Math.floor(Date.now() / 1000);
  return typeof payload.exp === "number" ? currentTime >= payload.exp : true;
};
